import { auth } from '../firebase';
import { env } from '../config/environment';
import userTeamService from './userTeamService';
import { getViewTimeZone } from '../utils/calendarTimeZone';

/**
 * Save this computer's timezone on the signed-in user's record (users/{email}.timeZone)
 * when it differs from what is stored, so people booking into this user's calendar
 * can see the meeting on this user's own clock. Fire-and-forget: the hint is optional.
 */
export async function syncMyTimeZone(email) {
  const timeZone = getViewTimeZone();
  if (!email || !timeZone) return;
  if (userTeamService.getUserConfig(email)?.timeZone === timeZone) return;
  try {
    const idToken = await auth.currentUser?.getIdToken();
    if (!idToken) return;
    await fetch(env.apiEndpoints.myTimeZone, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${idToken}` },
      body: JSON.stringify({ timeZone }),
    });
  } catch {
    /* offline or backend restarting: try again next sign-in */
  }
}
